function validateContent(
  blocked: boolean,
  verified: boolean,
  privated?: boolean
): boolean {
  return blocked ? false : !verified ? false : privated ? false : true;
}

export default validateContent;
